/* eslint semi:0 */
import m from 'mithril'
import BaseView from './BaseView'
import { get as getFromPdo, } from 'application/pageDataObject'


const ADMIN_ACTION_ITEM_CLASS = 'admin-dropdown-action dropdown-comp__item'

function getBlockElementClassName(blockName, elementName){
  return blockName && blockName.length && `.${ blockName }__${ elementName }` || elementName;
}

export default class AdminDropdownView extends BaseView {

  view({ vm, }){
    const { shouldShow, blockName, } = vm
    if (!shouldShow) {
      return null
    }
    const getElementClassName = getBlockElementClassName.bind(0, blockName)
    return [
      m(`label.label${ getElementClassName('label') }`, 'Options'),
      m(
        `nav.dropdown-comp${ getElementClassName('dropdown-menu') }`,
        this.adminDropdownActionsView(vm)
      ),
    ]
  }

  adminDropdownActionsView(vm){
    const actions = {}
    const view = []
    const { isAdmin, isAuthor, } = vm.store
    if (isAdmin) {
      Object.assign(actions, getFromPdo('post.admin_actions'))
    }
    const allowOpenInCastr = getFromPdo('post.allow_open_in_castr')
    if (isAdmin && allowOpenInCastr) {
      view.push(
        m(
          `a.${ ADMIN_ACTION_ITEM_CLASS }[href="/castr?id=${ getFromPdo('post.id') }"][target='_blank'][rel='noopener']`,
          'Open in Castr'
        )
      )
    }
    if (isAuthor || isAdmin) {
      const authorActions = getFromPdo('post.author_actions')
      view.push(
        m(
          `a.${ ADMIN_ACTION_ITEM_CLASS }[href="${ authorActions['Edit Post'] }"]`,
          'Edit Post'
        )
      )
      if (isAdmin) {
        view.push(
          m(
            `a.${ ADMIN_ACTION_ITEM_CLASS }[href="${ authorActions['Change Author'] }"][rel='nofollow']`,
            'Change Author'
          )
        )
      }
      const removePostAction = authorActions['Remove Post']
      if (removePostAction !== undefined) {
        Object.assign(actions, {
          'Remove Post': removePostAction,
        })
      }
    }
    const onclick = vm.handleAdminAction.bind(vm)
    for (const action in actions) {
      view.push(
        m(
          `a.${ ADMIN_ACTION_ITEM_CLASS }`,
          {
            onclick,
            rel: 'nofollow',
            href: actions[action],
          },
          action
        )
      )
    }
    return view
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/AdminDropdownView.js